import { Area, AreaChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { ScheduleRow } from '@app/shared';
import { formatCents } from '@/lib/format';

export function AmortizationChart({ rows, currency }: { rows: readonly ScheduleRow[]; currency: string }) {
  const data = rows.map((row) => ({
    installment: row.installment,
    year: row.dueDate.slice(0, 4),
    capital: row.principalCents / 100,
    interets: row.interestCents / 100,
  }));

  return (
    <div className="h-72 w-full">
      <ResponsiveContainer>
        <AreaChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
          <XAxis dataKey="year" interval="preserveStartEnd" tick={{ fontSize: 12 }} />
          <YAxis
            tick={{ fontSize: 12 }}
            tickFormatter={(value: number) => formatCents(Math.round(value * 100), currency)}
            width={70}
          />
          <Tooltip formatter={(value) => formatCents(Math.round(Number(value) * 100), currency)} />
          <Legend />
          <Area type="monotone" dataKey="capital" name="Capital" stackId="1" stroke="var(--color-primary)" fill="var(--color-primary)" fillOpacity={0.7} />
          <Area type="monotone" dataKey="interets" name="Intérêts" stackId="1" stroke="var(--color-muted-foreground)" fill="var(--color-muted-foreground)" fillOpacity={0.4} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
